const loginButton = {
    minWidth: "180px",
    backgroundColor: "#2A57A5",
    "&:hover": {
        backgroundColor: "#0288d1",
    },
};

export { loginButton };